import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  button: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fill: theme.palette.colors.white,
    marginRight: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/useStyles.js